import { CacheStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { TECHNICAL_SHEET_ROUTE_MACHINE, } from '../types/technical-sheet-route-machine.js';
/**
 * Descriptor for TechnicalSheetRouteMachine (Máquina por etapa do roteiro).
 * Subcollection: org/{orgId}/technical-sheet/{technicalSheetId}/route/{routeId}/routeMachine
 *
 * Resolve repository with context: { orgId, technicalSheetId, routeId }.
 */
export const technicalSheetRouteMachineDescriptor = {
    name: TECHNICAL_SHEET_ROUTE_MACHINE,
    label: 'Máquina por etapa do roteiro',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/technical-sheet/{technicalSheetId}/route/{routeId}/routeMachine',
    pathPatternKeys: {
        orgId: 'string',
        technicalSheetId: 'string',
        routeId: 'string',
    },
    version: 1,
    description: 'Máquina e tempos esperados de produção/setup por etapa do roteiro',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        // NoCache: filho de entidade versionada (spec 0045) — itens em cache voltariam velhos após Recarregar e seriam regravados por cima.
        cache: CacheStrategy.NoCache,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            description: 'Unique route-machine identifier',
        },
        {
            name: 'machineId',
            label: 'Máquina',
            type: 'string',
            required: true,
            description: 'Reference to the machine for this route step',
        },
        {
            name: 'expectedProductionTime',
            label: 'Tempo de produção esperado',
            type: 'number',
            required: false,
            description: 'Expected production time in milliseconds (0..MAX_DURATION_MS; null = not informed)',
        },
        {
            name: 'expectedSetupTime',
            label: 'Tempo de setup esperado',
            type: 'number',
            required: false,
            description: 'Expected setup time in milliseconds (0..MAX_DURATION_MS; null = not informed)',
        },
        {
            name: 'source',
            label: 'Origem',
            type: 'string',
            required: true,
            description: "Provenance: 'process' (imported from operation) or 'manual' (entered by user)",
        },
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [
        {
            fieldName: 'machineId',
            targetEntity: 'Machine',
            relationship: 'many-to-one',
            displayField: 'description',
            description: 'Máquina vinculada à etapa do roteiro',
        },
        ...AUDIT_FOREIGN_KEYS,
    ],
};
//# sourceMappingURL=technical-sheet-route-machine.descriptor.js.map